import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import cns from '../../node_modules/classnames/index.js';
import InfoTooltip from '../InfoTooltip/InfoTooltip.js';

function DropdownItem(_a) {
    var { children, className, disabled = false, divider = false, onClick, showInfo = false, infoContent, infoPosition = 'left' } = _a, others = __rest(_a, ["children", "className", "disabled", "divider", "onClick", "showInfo", "infoContent", "infoPosition"]);
    const classes = cns('dropdown__listItem', {
        'dropdown__listItem--disabled': disabled,
    }, className);
    return (divider
        ? jsx("li", { className: "divider", role: "separator" })
        : (jsxs("li", Object.assign({ className: classes }, others, { role: "menuitem", onClick: (event) => !disabled && onClick && onClick(event), children: [children, showInfo && (jsx("span", { "data-clickable": "false", style: { float: 'right' }, children: jsx(InfoTooltip, { left: infoPosition === 'left', right: infoPosition === 'right', children: infoContent }) }))] }))));
}

export { DropdownItem as default };
